<ng-container [formGroup]="formParent">
    <div class="form-group">        
        <label
            class="control-label"
            [ngClass] = "{'address-label': frmControl === 'address'}"
            [for]="frmControl"
            *ngIf="isLabelTop">
            {{label}}
            <span *ngIf="frmControl === 'address'" class = "address-container">
                <svg width="24" height="24" class = "address-advice" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M11 15V11M11 7H11.01M21 11C21 16.5228 16.5228 21 11 21C5.47715 21 1 16.5228 1 11C1 5.47715 5.47715 1 11 1C16.5228 1 21 5.47715 21 11Z" stroke="#E8AA14" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <span class = "address-advice-message">Consulta aquí tus direcciones guardadas desde tu perfil</span>
            </span>
        </label>
        <div class="select-wrapper" [class.open]="isOpen">
            <select
            #selectElement
            class="form-control"
            [style.color]="defaultColor ? '#1B1B1A' : '#807F7E'"
            [formControlName]="frmControl"
            (change)="optionSelected($event)">
                <option value="" selected class = "default-option">Selecciona una opción</option>
                <option *ngFor="let option of options" [value]="option.value || option.name">
                    {{option.name}}
                </option>
            </select>
            <!-- <fa-icon [icon]="faArrowDown"></fa-icon> -->
            <svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M13 1L7 7L1 1" [ngClass]="{'rotated': isOpen}" [style.stroke]="defaultColor ? '#1B1B1A' : '#807F7E'" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
        </div>
        
    </div>
</ng-container>

<ng-container *ngIf="control?.dirty && control?.invalid">
    <span class="help-block" *ngFor="let errorMessage of control['errorMessages']"> {{errorMessage}} </span>
    <span class="help-block" *ngIf="control.errors.async"> {{control.errors.async}} </span>
</ng-container> 